import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoanApplicationService {

  base_url: string | undefined;
  headers: any;

  headerObject: any = {}

  constructor(private http: HttpClient) {
    this.base_url = environment.url;

    const x_tenant_id = sessionStorage.getItem('locationCode');
    // console.log('X_TENANT_ID: ', x_tenant_id);

    this.headerObject = {
      Authorization:
        sessionStorage.getItem('token')!,
      'X-TENANT-ID': x_tenant_id,
    };

    this.headers = new HttpHeaders(this.headerObject);
  }

  // Pdf View API

  getPDFviewData(shgLoanId: number) {

    let headerObject: any = {
      Authorization:
        sessionStorage.getItem('token')!,
      'X-TENANT-ID': sessionStorage.getItem('locationCode')! || '101',
    };

    let headers = new HttpHeaders(headerObject);

    const requestOptions = {
      headers: headers,
    };



    return this.http.get(`${this.base_url}bankloanmis/shgloan/view?shgLoanId=${shgLoanId}`, requestOptions)
  }

  // Listing Page APIs

  getIndexPageList(params?: any) {

    // let headerObject:any = {
    //   Authorization:
    //   sessionStorage.getItem('token')!,
    //   'X-TENANT-ID': sessionStorage.getItem('locationCode')!,
    // };

    // let headers = new HttpHeaders(headerObject);

    // const requestOptions = {
    //   headers: this.headers,
    // };

    let paramStr = '?';

    const limit = 20;
    let offset = 0;

    paramStr += `limit=${limit}&offset=${offset * limit}&`;

    if (params) {
      for (let key in params) {
        if (params[key] !== null && params[key] !== '') {
          paramStr += `${key}=${params[key]}&`;
        }
      }
    }

    return this.http.get(`${this.base_url}bankloanmis/shgloan/loandetails${paramStr}`, {});
  }



  downloadCSVLoanApp(params: any = {}) {
    let endPoint = 'bankloanmis/admin/savedownloadcsvrequest'

    // const requestOptions = {
    //   headers: this.headers,
    //   params
    // };

    return this.http.get(
      `${this.base_url}${endPoint}`,
      { params },
    );
  }

  changeStatusOfApplication(shgLoanId: number, appStatus?: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    let payLoad = {
      "shgLoanId": shgLoanId,
      "status": 6
    }

    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/change-status`, payLoad, {}
    );
  }

  editMemberDeatilsApi(shgLoanId: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(`${this.base_url}bankloanmis/shgloan/getSavedShgDetails?shgLoanId=${shgLoanId}`, {})
  }
  // Entry Page APIs

  getGramPanchayatList() {
    const { stateId, districtId, blockId } = JSON.parse(sessionStorage.getItem('loginDetails')!)

    // Values needs to be done dynamic Dependency on BackEnd

    // console.log('BlcKCodedd: ', blockId , districtId, stateId);

    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/gp?stateId=${stateId}&districtId=${districtId}&blockId=${blockId}`,
      {});
  }

  getVillageList(gp_Id: any) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/village?gpId=${gp_Id}`,
      {}
    );
  }

  getShgDetails(params: any) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/shgloan/shgdetails`, { params }
    );
  }

  getBankList() {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/bank`,
      {}
    );
  }

  getBranchList(bnk_id: any) {
    const { level_Id } = JSON.parse(localStorage.getItem('block_code')!);

    // console.log('lllllll', level_Id);

    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/branch?bankId=${bnk_id}&levelId=${level_Id}`,
      {}
    );
  }

  saveBasicLoan(body: any, type: number, shgLoanId?: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    if (shgLoanId) {

      return this.http.post(
        `${this.base_url}bankloanmis/shgloan/saveshgdetails?basicDetailsDraft=${type}&shgLoanId=${shgLoanId}`,
        body,
        {}
      );
    } else {

      return this.http.post(
        `${this.base_url}bankloanmis/shgloan/saveshgdetails?basicDetailsDraft=${type}`,
        body,
        {}
      );
    }

  }

  getShgMembersList(shgDetails: any) {

    // console.log('Details of Shg: ', shgDetails);

    // const requestOptions = {
    //   headers: this.headers,
    // };

    let params = {
      shgLoanId: shgDetails.shgLoanId,
      stateShortCode: shgDetails.stateShortCode,
      shgCode: shgDetails.shgCode,
      shgId: shgDetails.shgId
    }

    return this.http.get(
      `${this.base_url}bankloanmis/shgloan/memberdocuments`,
      { params }
    );
  }

  getKycDocumentsList() {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/documents`,
      {}
    );
  }

  saveMemberKycDoc(body: any) {
    // console.log('Body:', body);

    // const requestOptions = {
    //   headers: this.headers,
    // };

    const formData = new FormData();
    for (const [key, value] of Object.entries(body)) {
      if (typeof value === 'string' || value instanceof Blob) {
        formData.append(key, value);
      } else {
        console.error(
          `Invalid value for key '${key}'. Expected string or Blob.`
        );
      }
    }
    // console.log('FormData: ', formData);

    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/savememberkyc`,
      formData,
      {}
    );
  }

  deleteMemberKyc(payLoad: any) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    // console.log('PayLoad delete Member: ', payLoad);


    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/delete-kyc`,
      payLoad,
      {}
    );
  }

  getLoanPurposeList() {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/master/loanpurpose`,
      {}
    );
  }

  saveMCPloanApplication(
    body: any,
    shgLoanId: number,
    type: number,
    appType: number
  ) {
    // const requestOptions = {
    //   headers: this.headers,
    // };



    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/mcp/saveloan?shgLoanId=${shgLoanId}&applicationType=${appType}&mcpDraft=${type}`,
      body,
      {}
    );
  }

  getMcpDetailsList(shgLoanId: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/shgloan/mcpdetails?shgLoanId=${shgLoanId}`,
      {}
    );
  }

  getParticularsList(shgLoanId: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(
      `${this.base_url}bankloanmis/shgloan/financial-detail?shgLoanId=${shgLoanId}`,
      {}
    );
  }

  saveFinancialLoanApplication(payLoad: any, shgLoanId: number, type: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/financials/saveloan?shgLoanId=${shgLoanId}&financialDraft=${type}`,
      payLoad,
      {}
    );
  }

  saveRenewalEnhanceApplication(payload: any, shgLoanId: number, type: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/saverenewalenhance?shgLoanId=${shgLoanId}&renewalEnhanceDraft=${type}`,
      payload,
      {}
    );
  }

  saveFinalApplication(payLoad: any) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.post(
      `${this.base_url}bankloanmis/shgloan/finalsubmit`, payLoad,
      {}
    );
  }

  getRenewalLoanApplication(shgLoanId: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(`${this.base_url}bankloanmis/shgloan/renewal-enhancement?shgLoanId=${shgLoanId}`, {})

  }

  checkApplicationStatus(shgCode: number) {
    // const requestOptions = {
    //   headers: this.headers,
    // };

    return this.http.get(`${this.base_url}bankloanmis/shgloan/appstatus-check?shgCode=${shgCode}`, {})

  }

  getShgId(shgDetails: any, loginDetails: any) {
    // console.log('SHG Details log: ', shgDetails, loginDetails);
    // let params = {
    //   stateShortCode: 'AS',
    //   shgCode: '04003393831'
    // }

    let params = {
      stateShortCode: loginDetails?.stateShortName,
      shgCode: shgDetails?.shgCode
    }

    return this.http.get(`${this.base_url}bankloanmis/shgloan/shgDetailAll`, { params })
  }


  getFinancialYearOptions(): { label: string; value: string }[] {
    const startYear = 2016; // Starting financial year
    const currentYear = new Date().getFullYear(); // Current year
    const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based

    const options = [];

    for (let year = startYear; year < currentYear; year++) {
      const financialYear = `${year}-${year + 1}`;
      options.push({ label: financialYear, value: financialYear });
    }

    if (currentMonth > 4) {
      // Include the current financial year
      options.push({ label: `${currentYear}-${currentYear + 1}`, value: `${currentYear}-${currentYear + 1}` });
    }

    return options;
  }

  getStateShortName(stateId: number): string {
    switch (stateId) {
      case 1: return 'AN'
        break;
      case 2: return 'AP'
        break;
      case 3: return 'AR'
        break;
      case 4: return 'AS'
        break;
      case 5: return 'BH'
        break;
      case 8: return 'GA'
        break;
      case 9: return 'GJ'
        break;
      case 10: return 'HR'
        break;
      case 11: return 'HP'
        break;
      case 12: return 'JK'
        break;
      case 13: return 'KA'
        break;
      case 14: return 'KL'
        break;
      case 15: return 'MP'
        break;
      case 16: return 'MH'
        break;
      case 17: return 'LA'
        break;
      case 18: return 'MN'
        break;
      case 19: return 'MG'
        break;
      case 20: return 'MZ'
        break;
      case 21: return 'NL'
        break;
      case 22: return 'OD'
        break;
      case 23: return 'PO'
        break;
      case 24: return 'PB'
        break;
      case 25: return 'RJ'
        break;
      case 26: return 'SK'
        break;
      case 27: return 'TN'
        break;
      case 28: return 'TR'
        break;
      case 29: return 'UP'
        break;
      case 30: return 'WB'
        break;
      case 31: return 'CG'
        break;
      case 32: return 'JH'
        break;
      case 33: return 'UK'
        break;
      case 34: return 'TS'
        break;
      case 35: return 'LK'
        break;
      case 36: return 'DD'
        break;
      case 91: return 'DEV'
        break;
      case 92: return 'DEMO'
        break;

      default:
        return '';
        break;
    }
  }

}

